import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import CompanyUser from "../../models/company-user";
import { useSelector } from "react-redux";

interface UserDeleteModalProps {
  show: boolean;
  user?: CompanyUser;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const UserDeleteModal: React.FC<UserDeleteModalProps> = ({
  show,
  user,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const companyId = useSelector((state: any) => state.company.data.company.id);

  const message = user
    ? `Está seguro de que quiere eliminar el usuario ${user.email}`
    : "";

  const onDeleteClick = async () => {
    if (user !== undefined) {
      setSubmitting(true);
      const userStatus = await deleteItem<CompanyUser>(
        `/company_users/${companyId}/users/${user.id}/`,
        user
      );

      if (userStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (userStatus.detail !== undefined) {
          message = userStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default UserDeleteModal;
